export default "__VITE_ASSET__qNeMlU8E__"